// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"2b358f2a","726":"da9bf3a9","843":"374d38fa","893":"6f8b3e5a"}[chunkId] + ".chunk.js";
};